const CONTACT = {
    whatsapp: 'https://wa.me/5553920025387',
    email: 'contato@whizr.app',
};

export default CONTACT